module.exports = __webpack_public_path__ + "static/into-the-light.3445f11c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/into-the-light.jpg
// module id = 1084
// module chunks = 35783957827783